import { render, staticRenderFns } from "./full-comparison.vue?vue&type=template&id=449d0777"
import script from "./full-comparison.vue?vue&type=script&lang=js"
export * from "./full-comparison.vue?vue&type=script&lang=js"
import style0 from "./full-comparison.vue?vue&type=style&index=0&id=449d0777&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports